import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {useSelector} from 'react-redux';

const PrivateRoute = ({children, setCurrentPathname, ...props}) => {
    const user = useSelector(state => state.user);

    setCurrentPathname && setCurrentPathname(window.location.pathname);

    return (
        <Route {...props}>
            {user && user.jwtToken ? children : <Redirect to="/" />}
        </Route>
    );
};

export default PrivateRoute;
